import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { SettingsModel, SettingsWrapper } from '../../model/SettingsModel';
import { AppSettingsService } from './appsettings.service';
import { AuthService } from './authentication.service';
import { RequestResult } from '../../model/RequestResult';

@Injectable()
export class SettingsService {

    private appSettingsApi: SettingsModel;

    constructor(private authHttp: AuthService, private appSettingsService: AppSettingsService) {

        this.getSettings().then(response => {
            this.appSettingsApi = response;
        });
    }

    getSetting(name: any) {
        if (this.appSettingsApi == null) {
            this.getSettings().then(response => {
                this.appSettingsApi = response;
                return this.appSettingsApi.SettingsList.find(x => x.Name == name);
            });
        }

        return this.appSettingsApi.SettingsList.find(x => x.Name == name);
    }

    getSettings(): Promise<SettingsModel> {
        let url = this.appSettingsService.getAppSetting('apiUri') + 'settings/get';
        return this.authHttp.authGet(url).then(response => {
            let userList: SettingsModel = JSON.parse(<string>response.data);
            return userList;
        }).catch(this.handleError);
    }

    getVersion(): Promise<string> {
        let url = this.appSettingsService.getAppSetting('apiUri') + 'settings/getVersion';
        return this.authHttp.authGet(url).then(response => {
            return JSON.parse(<string>response.data);            
        }).catch(this.handleError);
    }

    setSettings(model: SettingsModel): Promise<RequestResult> {
        let url = this.appSettingsService.getAppSetting('apiUri') + 'settings/save';
        return this.authHttp.authPost(url, model).then(response => {
            return response;
        });
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/settings.service.ts